import { Pipe, PipeTransform } from '@angular/core';

import { PaxAmount } from '@fcom/dapi/interfaces/pax-details.interface';

@Pipe({
  name: 'finFormatPassenger',
  standalone: false,
})
export class FormatPassengerPipe implements PipeTransform {
  transform(
    trans: Partial<Record<'adult' | 'adults' | 'child' | 'children' | 'infant' | 'infants', string>>,
    paxAmount: PaxAmount
  ): string {
    return this.formatPaxAmount(paxAmount, trans);
  }

  private formatPaxAmount = (
    paxAmount: PaxAmount,
    trans: Partial<Record<'adult' | 'adults' | 'child' | 'children' | 'infant' | 'infants', string>>
  ): string => {
    if (!paxAmount || !trans) {
      return '';
    }
    const info: string[] = [];
    const adults = paxAmount.adults;
    if (adults > 0) {
      info.push(`${adults} ${adults === 1 ? trans.adult : trans.adults}`);
    }
    const children = paxAmount.children + paxAmount.c15s;
    if (children > 0) {
      info.push(`${children} ${children === 1 ? trans.child : trans.children}`);
    }
    const infants = paxAmount.infants;
    if (infants > 0) {
      info.push(`${infants} ${infants === 1 ? trans.infant : trans.infants}`);
    }
    return info.join(', ');
  };
}
